import React from 'react'
import { Link } from 'react-router-dom'
import { getOurApproachData } from '../dataHelp'
import Footer from './presentational/Footer'
import Header from './presentational/Header'

function Aboutus() {
  const getBannerSection = () => {
    return (
      <div
        className="aboutusBgCont"
        style={{ backgroundImage: "url(imgs/about.jpg)" }}
      >
        <div className="aboutusTxtCont">
          <div className="txt">
            <h1 className="font-bold font-60 mb-4">About Us</h1>
            <p className="mt-2 font-25">
              At Equation Hub, we are dedicated to empowering students to excel in mathematics, from
              Kindergarten to Grade 12. Our mission is simple: to make math accessible, enjoyable, and
              understandable for all students. Through personalized instruction, innovative teaching methods,
              and a supportive learning environment, we help every student build confidence and achieve
              their academic goals
            </p>
          </div>
        </div>
      </div>
    )
  }
  const ourStorySect = () => {
    return(
      <div className="row justify-content-center align-items-center mt-5">
        <div className="col-md-4">
          <img src="/imgs/about-us.jpg" style={{borderRadius: "1.25rem", objectFit: 'cover'}} height="310px" width="100%" />
        </div>
        <div className="col-md-6 ps-5">
          <h2 className="font-bold font-50">Our Story</h2>
          <p className="mb-2 mt-3 font-18">Founded by Mr. Malik, an Ontario Certified Teacher with a passion for education, Equation Hub
            was created to address the unique learning needs of every child. Mr. Malik has been tutoring
            kids in his community since he was in grade 10, which was back in 2009. With a background in
            Early Childhood Development, a Bachelor’s in Child Development, and a Bachelor’s in
            Education, he has taught students ranging from Kindergarten to Grade 11. Drawing from years
            of experience as a Kindergarten teacher, Mr. Malik saw the need for a math tutoring center that
            goes beyond traditional methods. He focused on creating a center that emphasizes
            individualized support, interactive learning, and a genuine love for the subject.</p>
        </div>
      </div>
    )
  }
  const ourApproachSect = () => {
    return (
      <div className="row justify-content-center mt-5 pt-3">
        <div className="col-md-9 px-0 text-center">
          <h2 className="font-bold font-50">Our Approach</h2>
          <p className="mb-2 font-18 px-4">At Equation Hub, we believe in a holistic and student-centered approach to learning</p>
          <div className="row mt-5 approach-sect-cont">
            {getOurApproachData().map((item, index) => {
              return (
                <div key={item.icon} className="col-md-4 col-8">
                  <div className="border-0 card about-us-card px-4 py-2 text-start">
                    <i className={`${item.icon} text-primary font-50 mt-3 mb-3`} />  
                    <h5 className="font-25 mb-2">{item.title}</h5>
                    <p className="text-muted">{item.description}</p>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
  const contactUsSect = () => {
    return(
      <div className="row justify-content-center mt-5 pt-3 pb-4">
        <div className="col-md-11 px-0">
          <h2 className="font-bold font-50 text-center">Contact Us</h2>
          <div className="row justify-content-center">
            <div className="col-md-8 text-center">
              <p className="font-18 mb-4">Ready to learn more or schedule a free consultation? Contact us today and discover how Equation Hub can help your child succeed in math!</p>
              <div className="d-flex aic justify-content-center mt-4">
                <div className="icon me-2 text-center">
                  <i className="fas fa-envelope text-primary" />
                </div>
                <a href="mailto:equationhub.info@gmail.com" className="text-decoration-none text-dark">equationhub.info@gmail.com</a>
              </div>
              <div className="d-flex aic justify-content-center mt-3">
                <div className="icon me-2 text-center">
                  <i className="fas fa-phone text-primary" />
                </div>
                <a href="tel:+19054096284" className="text-decoration-none text-dark">(905) 409-6284</a>
              </div>
              <Link to="/locations" className="btn contantBtn px-4 py-2 mt-4">
                View Our Locations
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div className="about-page">
      <Header />
        {getBannerSection()}
        {ourStorySect()}
        {ourApproachSect()}
        {contactUsSect()}
      <Footer />
    </div>
  )
}

export default Aboutus
